import { Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useContext, useEffect } from "react";
import { Context } from "../context/MainContext";

const AuthLayout = () => {
  const { user } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.id) {
      navigate("/dashboard");
    }
  }, [user?.id, navigate]);

  return (
    <div className="authLayout">
      <div className="authLayout__left">
        <img src={logo} alt="Logo" />

        <h1>Admin Panel</h1>
        {/* <Button height="40px" type="btnMain">
          Learn More
        </Button> */}
      </div>

      <div className="authLayout__right">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
